import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDeleteOrderMutation } from 'api/generated/graphql';
import { useError, useNotifyMessages } from 'api/helpers';

export const useDeleteOrder = () => {
  const [handle, { loading, error: apolloError }] = useDeleteOrderMutation();

  const notifyMessages = useNotifyMessages();

  const error = useError(apolloError);

  const deleteOrder = useCallback(
    async (id: string, versionNumber: number) => {
      const res = await handle({
        variables: { id, versionNumber },
      });

      if (res.data?.deleteOrder?.messages) {
        notifyMessages(res.data.deleteOrder.messages);
      }

      return res.data?.deleteOrder?.data;
    },
    [handle, notifyMessages]
  );

  return {
    loading,
    error,
    deleteOrder,
  };
};
